export default {"src":"/_next/static/media/houses_40.d8c333d0.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};